import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Họ và tên", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Số điện thoại", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Địa chỉ", -1)
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Giới tính", -1)
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "CMND/CCCD/Passport", -1)
const _hoisted_12 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Mã đối tượng được lấy mẫu", -1)
const _hoisted_14 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "dateBirthday" }, "Chọn ngày sinh:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)
const _hoisted_17 = { class: "p-field p-col-12 p-sm p-md-4" }
const _hoisted_18 = { class: "p-field p-col-12 p-sm p-md-4" }
const _hoisted_19 = { class: "p-field p-col-12 p-sm p-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Cập nhật thông tin người được xét nghiệm" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              id: "fullname",
              type: "text",
              modelValue: $setup.thongTinUpdate.ten,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.thongTinUpdate.ten) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              id: "username",
              type: "text",
              modelValue: $setup.thongTinUpdate.soDienThoai,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.thongTinUpdate.soDienThoai) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_InputText, {
              id: "username",
              type: "text",
              modelValue: $setup.thongTinUpdate.diaChiCuThe,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.thongTinUpdate.diaChiCuThe) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Dropdown, {
              id: "sex",
              modelValue: $setup.thongTinUpdate.gioiTinh,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.thongTinUpdate.gioiTinh) = $event)),
              options: $setup.gioiTinh,
              optionLabel: "value",
              optionValue: "value"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_InputText, {
              id: "cmnd",
              type: "text",
              modelValue: $setup.thongTinUpdate.cmnd,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.thongTinUpdate.cmnd) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_Dropdown, {
              id: "maDoiTuong",
              filter: true,
              showClear: true,
              modelValue: $setup.thongTinUpdate.maDoiTuong,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.thongTinUpdate.maDoiTuong) = $event)),
              options: $setup.thongtinDoiTuong,
              optionLabel: "maDoiTuong",
              optionValue: "maDoiTuong",
              placeholder: " - Chọn mã đối tượng -",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_Calendar, {
              id: "dateselect",
              modelValue: $setup.thongTinUpdate.ngaySinh,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.thongTinUpdate.ngaySinh) = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "1900:2050"
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Dropdown, {
              id: "province",
              filter: true,
              showClear: true,
              modelValue: $setup.province,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.province) = $event)),
              onChange: $setup.selectProvince,
              options: $setup.provinces,
              optionLabel: "provinceName",
              optionValue: "provinceCode",
              placeholder: " - Chọn Tỉnh/Thành 1 -"
            }, null, 8, ["modelValue", "onChange", "options"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_Dropdown, {
              id: "district",
              filter: true,
              showClear: true,
              modelValue: $setup.district,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.district) = $event)),
              options: $setup.districts,
              onChange: $setup.selectDistrict,
              optionLabel: "districtName",
              optionValue: "districtCode",
              placeholder: " - Chọn Quận/Huyện -",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_Dropdown, {
              id: "ward",
              filter: true,
              showClear: true,
              modelValue: $setup.ward,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.ward) = $event)),
              options: $setup.wards,
              optionLabel: "wardName",
              optionValue: "wardCode",
              placeholder: " - Chọn Phường/Xã -",
              style: {"text-align":"center"}
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_Button, {
          label: "Cập nhật",
          icon: "pi pi-user-edit",
          disabled: !$setup.valid(),
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.update())),
          style: {"margin-right":"20px"}
        }, null, 8, ["disabled"]),
        _createVNode(_component_Button, {
          label: "Xoá",
          class: "p-button-danger",
          icon: "pi pi-user-minus",
          iconPos: "left",
          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.del($event)))
        })
      ]),
      _: 1
    })
  ], 64))
}